const instantUploader = require('frontend-controller/lib/controllers/modals/instantUploader')
const utils = require("frontend-controller/lib/utils")

module.exports = {
	config: {
		roleOptionScope: 'mblx',
	},

	model: {
		entityTable: false
	},

	events: {
		action: {
			type: 'click',
			selector: 'section.top button',
			async action(event){
				event.preventDefault();
				event.stopImmediatePropagation();

				var self = event.data.component;
				var $target = $(event.target);
				if($target.length > 0){
					var fieldType = $target.data('fieldType');
					if(self.model.entityTable){
						if(fieldType === 'import') {
							self.showImport()
						} else if(fieldType === 'refresh'){
							self.model.entityTable.refreshData()
						} else if(fieldType === 'requestProductsAdditionalInformation'){
							const resourceFilters 	= utils.copy(self.model.entityTable.getResourceFilters(self.getStorage(), undefined, 'refreshResources')) || {}
							const {nrOfMatchingElements} = (((self.model.entityTable.resourceData || {}).nrOfElements || {}).data || {}).attributes || {}
							const nrOfEditStatusPimElements = (self.model.entityTable.resourceData || {}).nrOfEditStatusPimElements || 0
							await getComponent('mblxController').requestProductAdditionalInformation('productAdditionalInformationFilters', undefined, undefined, resourceFilters.filters || {}, nrOfMatchingElements, nrOfEditStatusPimElements)
						}
					}
				}
			}
		}
	},

	methods: {
		showImport(){
			return this.performAndStoreAction(
				'showImport_inEffect',
				this.prepareAction(
					instantUploader.getAction({
						model: {
							titleKey: 'modal.productAdditionalInformation.importerUploader.title',
						}
					}, {
						component: [
							'/',
							'templates',
							'mblx',
							'products',
							'additionalInformation',
							'importerUploader',
						]
					})
				),
				true
			)
		}
	},

	hooks: {
		attach: function($element, options){
			var self = this;
			if(!self.model.entityTable){
				self.find('base_tableSimple_table', function(entityTable){
					self.model.entityTable = entityTable;
				});
			}
		},

		filtersChanged: function($element, options){
			this.triggerFind('filtersChanged', options);
		},

		showColumnDescription: function ($element, options) {
			this.triggerFind('showColumnDescription', options);
		},

		hideColumnDescription: function ($element, options) {
			this.triggerFind('hideColumnDescription', options);
		},
	}
};
